<template>
  <v-layout row wrap>
    <!-- Dialog -->
    <v-dialog v-model="json_data.status" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card style="background-color:#EEEEEE;">
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <v-btn slot="activator" icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{ $t('close') }}</span>
          </v-tooltip>
          <v-toolbar-title>{{ json_data.save_type == 'create' ? $t('menu.ChangePlanCreate') : $t('menu.ChangePlanEdit')
            }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-4>
            <v-layout row wrap pa-4 style="background-color:#fff; margin-top:5px; border-radius:5px;">
              <v-flex xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field :label="$t('doc_no')" append-icon="fas fa-plus-circle" hide-details v-if="json_data.save_type == 'create' "
                        v-model="form_model.doc_no" :rules="form_rules.doc_no" required @click:append="doNewGuid" />
                      <v-text-field v-else :label="$t('doc_no')" append-icon="fas fa-plus-circle" hide-details readonly
                        v-model="form_model.doc_no" :rules="form_rules.doc_no" required />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-autocomplete hide-details :loading="loading" v-model="form_model.emp_code" :items="Employee_List"
                        item-text="name" item-value="code" :label="$t('employee_code')" allow-overflow append-icon="search"
                        clearable required :rules="form_rules.emp_code" />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field :label="$t('new_holiday_date')" v-model="form_model.new_holiday_date" :rules="form_rules.new_holiday_date"
                        required hide-details type="date" />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field :label="$t('old_holiday_date')" v-model="form_model.old_holiday_date" :rules="form_rules.old_holiday_date"
                        required hide-details type="date" />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-select :items="profilePlan" :label="$t('Changeplan_dialog_comeworkplan')" item-text="name" item-value="code"
                        hide-details v-model="form_model.profile" :rules="form_rules.profile" required />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-select :items="profileConditions" :label="$t('Deduction_conditions')" item-text="name" item-value="code"
                        hide-details v-model="form_model.profile_condition" :rules="form_rules.profile_condition"
                        required />
                    </v-flex>
                    <v-flex md12 sm12 xs12 pa-1>
                      <v-textarea :label="$t('remark')" v-model="form_model.remark" hide-details />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn color="success" @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
     <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
  /* eslint-disable */
  import {
    mapState,
    mapActions,
    mapMutations,
    mapGetters
  } from "vuex";
  import Utils from "@/utils/";
  import DocumentService from "@/services/DocumentService";
  import SettingService from "@/services/SettingService";

  export default {
    props: {
      json_data: Object
    },
    watch: {
      json_data(val) {
        if (val.data != null) {
          this.form_model = val.data;
          this.form_model.profile = val.data.profile != null ? val.data.profile.toString() : '';
          this.form_model.profile_condition = val.data.profile_condition != null ? val.data.profile_condition.toString() : '';         
        } else {
          this.$refs.form.resetValidation();
        }
      }
    },
    data: () => ({
      form_valid: false,
      form_rules: {
        emp_code: [v => !!v || "do not empty."],
        doc_no: [v => !!v || "do not empty."],
        new_holiday_date: [v => !!v || "do not empty."],
        old_holiday_date: [v => !!v || "do not empty."],
        profile: [v => !!v || "do not empty."],
        profile_condition: [v => !!v || "do not empty."]
      },
      form_model: {
        emp_code: "",
        doc_no: "",
        request_date: "",
        new_holiday_date: new Date().toISOString().slice(0, 10),
        old_holiday_date: new Date().toISOString().slice(0, 10),
        remark: "",
        profile: "",
        profile_condition: "",
        is_approve: "1",
        creator_code: localStorage._usercode
      },
      profilePlan: [],
      profileConditions: [],
      snack_model: {
        status: "",
        msg: "",
        type: ""
      }
    }),
    created: function () {
      this.getProfilePlan();
      this.getProfileConditions();
      this.getEmployee("newData");
      this.doNewGuid();
    },
    computed: {
      ...mapState("filter", ["loading", "Employee_List"])
    },
    methods: {
      ...mapActions("filter", ["getEmployee"]),
      closeDialog() {
        this.clearForm();
        this.$emit("close-dialog");
      },
      clearForm() {
        this.form_model = {
            emp_code: "",
            doc_no: "",
            request_date: "",
            new_holiday_date: new Date().toISOString().slice(0, 10),
            old_holiday_date: new Date().toISOString().slice(0, 10),
            remark: "",
            profile: "",
            profile_condition: "",
            is_approve: "1",
            creator_code: localStorage._usercode
          }
      },
      showSnackBar(msg, type) {
        this.snack_model.msg = msg;
        this.snack_model.type = type;
        this.snack_model.status = true;
      },
      doNewGuid() {
        this.form_model.doc_no = Utils.newGuid('CP');
      },
    getProfilePlan() {
      this.profilePlan=[];
      this.profilePlan.push({
        code : "",
        name : "ไม่ใช้แผนการทำงาน",
      });
      SettingService.getProfileAllPlan()
        .then(res => {
         res.data.content.forEach(element => {
            this.profilePlan.push({
            code : element.code,
            name : element.name,
          })
          }); 
          //this.profilePlan = res.data.content;
          console.log(this.profilePlan);
        })
        .catch(err => {
          //console.log(err);
        });
    },
      getProfileConditions() {
        this.profileConditions = [];
        SettingService.getProfileConditions()
          .then(res => {
            this.profileConditions = res.data.content;
          })
          .catch(err => {
            this.showSnackBar(err.response.data, 'error');
          });
      },
      onSave() {
        if (this.form_valid) {
          DocumentService.createChangePlan(this.form_model)
            .then(res => {
              this.showSnackBar('save success', 'success');
              this.closeDialog();
            })
            .catch(err => {
              this.showSnackBar(err.response.data, 'error');
            });
        } else {
          this.$refs.form.validate();
        }
      },
      onUpdate() {
        if (this.form_valid) {
          DocumentService.updateChangePlan(this.form_model)
            .then(res => {
              this.showSnackBar('update success', 'success');
              this.closeDialog();
            })
            .catch(err => {              
              this.showSnackBar(err.response.data, 'error');
            });
        } else {
          this.$refs.form.validate();
        }
      }
    }
  };
</script>
<style>
 
   .v-card__text{
    padding:0px !important;
  }
</style>